import { ComponentProps } from 'react'

import { FontWeight, Heading } from '../../../types/types'
import { astraTwMerge } from '../../Utilities/astraTwMerge'

// Font weights from the Astra design system
const fontWeight: Record<FontWeight, string> = {
    regular: 'font-hero-regular',
    medium: 'font-hero-medium',
    strong: 'font-hero-strong',
}

const fontSize: Record<Heading, string> = {
    h1: 'text-h1 leading-h1 tracking-h1',
    h2: 'text-h2 leading-h2 tracking-h2',
    h3: 'text-h3 leading-h3 tracking-h3',
}

/**
 * Although the AstraHeading component can be any of h1-h6, the type for all of them is the same:
 * DetailedHTMLProps<HTMLAttributes<HTMLHeadingElement>, HTMLHeadingElement>.
 * For simplicity, we use ComponentProps<'h1'>.
 */
type Props = ComponentProps<'h1'> & {
    as?: Heading
    /**
     * @example weight="regular" | weight="medium" | weight="strong"
     */
    weight?: FontWeight
}

/**
 * Page and section headings in the Astra type scale. `as` chooses the semantic element (h1 to h3) and also the
 * visual size, so pick it to match the document outline. `weight` changes emphasis only. For body text use
 * AstraParagraph.
 *
 * @summary for page and section headings
 */
export const AstraHeading = ({ ref, children, as: Comp = 'h1', weight = 'strong', className, ...props }: Props) => (
    <Comp ref={ref} className={astraTwMerge(`${fontSize[Comp]} ${fontWeight[weight]} text-default`, className)} {...props}>
        {children}
    </Comp>
)
